import { imgix } from '@lib/imigx'
import { getProductAvailability } from './get-product-availability'
import { ProductDescriptionSchemaDetails } from '..'

export function getGassanProductSchemaDetails(data: ProductDescriptionSchemaDetails): any {
  let image = ''

  const { article, brandDescription } = data

  if (article && article.images && article.images.length > 0) {
    image = imgix(article.images[0] as string, { width: 750 })
  }

  const availability = getProductAvailability({ data: article })

  const cleanedBrandDescription =
    typeof brandDescription === 'string'
      ? brandDescription.replace(/\s+/g, ' ').trim()
      : brandDescription

  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: `${article.brand} ${article.description}`,
    image,
    description: cleanedBrandDescription,
    brand: {
      '@type': 'Brand',
      name: article.brand,
    },
    offers: {
      '@type': 'Offer',
      price: (article.price / 100).toFixed(2),
      priceCurrency: 'EUR',
      availability,
      itemCondition: 'https://schema.org/NewCondition',
    },
  }
}
